{
  "actions": {
    "cancel": "Cancel"
  },
  "status": {
    "DRAFT": "Draft",
    "SUBMITTED": "Awaiting approval",
    "APPROVED": "Approved",
    "RETURNED": "Returned"
  },
  "myTime": {
    "title": "My time",
    "off": "Time is turned off for your company",
    "offBody": "An administrator can turn it on in Settings › Projects.",
    "noProjects": "There's no project you can log time on",
    "noProjectsBody": "You log time on open projects where you're an active team member and Time is on. Ask the project's manager to add you to the team.",
    "noProjectsShort": "You're not on a project you can log time on."
  },
  "week": {
    "range": "{{from}} – {{to}}",
    "this": "This week",
    "nav": "Week",
    "previous": "Previous week",
    "next": "Next week"
  },
  "view": {
    "label": "View",
    "week": "Week",
    "day": "Day"
  },
  "figures": {
    "label": "Hours this week",
    "week": "Week total"
  },
  "submit": {
    "button": "Submit week",
    "title": "Submit {{hours}} for approval?",
    "body_one": "{{n}} draft or returned entry of {{week}} goes to the project's approvers. You can't change it unless they return it.",
    "body_other": "{{n}} draft or returned entries of {{week}} go to the projects' approvers. You can't change them unless they return them.",
    "saveFirst": "Your changes in the grid are saved first.",
    "confirm": "Submit week",
    "saveAndSubmit": "Save and submit",
    "toast_one": "{{n}} entry submitted ({{hours}})",
    "toast_other": "{{n}} entries submitted ({{hours}})",
    "nothing": "There's no draft or returned time to submit this week.",
    "locked_one": "{{n}} entry before {{date}} stays as a draft: its day is locked.",
    "locked_other": "{{n}} entries before {{date}} stay as drafts: their days are locked.",
    "stayed_one": "{{n}} entry stayed as a draft: its day is locked.",
    "stayed_other": "{{n}} entries stayed as drafts: their days are locked."
  },
  "unsaved": {
    "title": "Discard the time you typed?",
    "body": "Changes in the grid are not saved yet.",
    "discard": "Discard",
    "keep": "Keep editing"
  },
  "grid": {
    "section": "Week grid",
    "label": "Time for the week",
    "rowHeading": "Project › plan › task",
    "addRow": "Add row",
    "save": "Save",
    "discard": "Discard changes",
    "saved": "Time saved",
    "unsaved_one": "{{n}} row changed",
    "unsaved_other": "{{n}} rows changed",
    "notSaved_one": "{{n}} entry stopped the save",
    "notSaved_other": "{{n}} entries stopped the save",
    "notSavedBody": "Nothing was saved. Fix the marked cells and save again.",
    "alreadyThere": "That row is already in the week.",
    "billable": "Billable",
    "billableRow": "Billable: {{row}}",
    "removeRow": "Remove row {{row}}",
    "rowOptions": "Billable and remove",
    "several": "Several entries",
    "openDay": "Open {{day}} to change them",
    "returned": "Returned for {{day}}:",
    "returnReason": "Reason for return: {{reason}}",
    "noReason": "No reason given.",
    "empty": "No time this week yet",
    "emptyBody": "Add a row for a project, then type the hours under each day.",
    "help": "Type hours as 7.5, 7:30 or 7h30. Arrow keys move between cells, Enter keeps a value, Escape undoes it.",
    "lock": {
      "several_one": "{{n}} entry: change it on the day",
      "several_other": "{{n}} entries: change them on the day",
      "SUBMITTED": "Submitted, awaiting approval",
      "APPROVED": "Approved",
      "entry": "This entry can no longer be changed",
      "notLoggable": "You can't log time on this project now",
      "before": "Time before {{date}} can't be changed",
      "after": "Time after {{date}} can't be logged yet"
    }
  },
  "addRow": {
    "title": "Add a row",
    "description": "Choose the project, and the part of its plan and the task if you like.",
    "submit": "Add row"
  },
  "target": {
    "project": "Project",
    "projectPlaceholder": "Choose a project",
    "search": "Search…",
    "noProjects": "No project matches.",
    "node": "Plan node",
    "nodeHint": "Optional: the phase or work package.",
    "nodePlaceholder": "Whole project",
    "noNodes": "No plan node matches.",
    "noNode": "Whole project",
    "task": "Task",
    "taskRequired": "This project logs time against a task.",
    "taskPlaceholder": "No task",
    "noTasks": "No task matches.",
    "noTask": "No task",
    "restrictedTask": "(restricted task)"
  },
  "log": {
    "title": "Log time",
    "editTitle": "Change time",
    "description": "Hours you worked on a project. Your manager approves them.",
    "date": "Day",
    "hours": "Hours",
    "hoursHint": "7.5, 7:30 or 7h30",
    "note": "Note",
    "billable": "Billable to the customer",
    "billableFixed": "Billable: this project bills its time.",
    "notBillableFixed": "Not billed: this project doesn't bill time.",
    "returned": "Returned to you",
    "notOnProject": "You can't log time on this task's project. Choose another project.",
    "submit": "Log time",
    "save": "Save",
    "errors": {
      "project": "Choose a project.",
      "task": "Choose a task: this project logs time against tasks.",
      "hours": "Enter hours like 7.5, 7:30 or 7h30, up to 24.",
      "hoursRequired": "Enter the hours."
    },
    "toast": {
      "logged": "{{hours}} logged",
      "saved": "Time saved"
    }
  },
  "day": {
    "section": "Day list",
    "days": "Days of the week",
    "none": "no time",
    "log": "Log time",
    "empty": "No time on {{day}}",
    "entries": "Time on {{day}}"
  },
  "entry": {
    "billable": "Billable",
    "notBillable": "Not billable",
    "returned": "Returned:",
    "edit": "Edit",
    "editLabel": "Edit {{hours}} on {{project}}",
    "delete": "Delete",
    "deleteLabel": "Delete {{hours}} on {{project}}",
    "deleteTitle": "Delete {{hours}}?",
    "deleteBody": "The entry for {{day}} is removed.",
    "deleted": "Time deleted"
  },
  "approvals": {
    "title": "Time approvals",
    "intro": "Time waiting for your decision, by person and week.",
    "meta_one": "{{n}} entry waiting for a decision",
    "meta_other": "{{n}} entries waiting for a decision",
    "empty": "No time waits for your approval",
    "emptyBody": "Submitted time on your projects appears here.",
    "groupLabel": "Time of {{person}}, {{week}}",
    "total": "Total",
    "billable": "Billable",
    "selfGroup": "Your own time: someone else approves it.",
    "self": "Your own time: someone else approves it",
    "cannot": "You can't decide this entry",
    "selectGroup": "Select all of {{person}}'s entries",
    "selectEntry": "Select {{hours}} on {{day}}, {{project}}",
    "selected_one": "{{n}} entry selected · {{hours}}",
    "selected_other": "{{n}} entries selected · {{hours}}",
    "approve": "Approve selected",
    "return": "Return…",
    "approved_one": "{{n}} entry approved ({{hours}})",
    "approved_other": "{{n}} entries approved ({{hours}})",
    "returnTitle_one": "Return {{n}} entry?",
    "returnTitle_other": "Return {{n}} entries?",
    "returnBody": "The person sees your reason, corrects the time and submits it again.",
    "reason": "Reason",
    "reasonHint": "Say what to change.",
    "reasonRequired": "Say what to change.",
    "returnConfirm": "Return",
    "returned_one": "{{n}} entry returned",
    "returned_other": "{{n}} entries returned",
    "notDecided_one": "{{n}} entry stopped the decision",
    "notDecided_other": "{{n}} entries stopped the decision",
    "notDecidedBody": "Nothing was decided. Leave out the marked entries and try again.",
    "badge_one": "{{n}} entry waiting",
    "badge_other": "{{n}} entries waiting",
    "columns": {
      "date": "Day",
      "work": "Project › plan › task",
      "billable": "Billable",
      "hours": "Hours"
    },
    "changed": "Some of these entries changed since you opened the list. It's refreshed: check them and decide again.",
    "truncated": "Only the first 2,000 entries are shown. Choose a project to see the rest.",
    "project": "Project",
    "allProjects": "All projects",
    "meta_zero": "Nothing waits for a decision"
  },
  "logTime": {
    "button": "Log time",
    "forTask": "Log time on {{number}}"
  },
  "taskHours": {
    "title": "Time logged",
    "approved": "Approved",
    "submitted": "Awaiting approval",
    "people": "People"
  },
  "errors": {
    "PROJECT_NOT_MEMBER": "Only active team members log time on this project. Ask its manager to add you.",
    "SELF_APPROVAL": "Nobody approves their own time: someone else decides it.",
    "TIME_ENTRY_BILLED": "This time is on a customer invoice. Void the invoice first.",
    "TIME_ENTRY_POSTED": "This time is in a labour posting. Void the posting first.",
    "TIME_ENTRY_ILLEGAL_MOVE": "This entry has moved on since: refresh and check its status.",
    "TIME_DATE_LOCKED": "This day is outside the dates that can be logged or changed.",
    "minutes": "Check the hours: a day can't go over 24 hours.",
    "task": "Choose a task of this project that you can see.",
    "item": "This entry couldn't be saved."
  }
}
